<template>
  <div>
    <div id="container">
        <span id="text1"></span>
        <span id="text2"></span>
    </div>

    <svg id="filters">
        <defs>
            <filter id="threshold">
                <feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      0 0 0 255 -140" />
            </filter>
        </defs>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'text-morph',
  props: {
    texts: {
      type: Array,
      required: true,
    },
    fontSize: {
      type: Number,
      default: 30,
    },
    morphSpeed: {
      type: Number,
      default: 1,
    },
    cooldownTime: {
      type: Number,
      default: 0.4,
    },
    program: {
      type: String,
      default: 'continuous',
      validator: value => ['continuous', 'single'].includes(value),
    },
    doneCallback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      elts: {
        text1: document.getElementById('text1'),
        text2: document.getElementById('text2'),
      },
      textIndex: 0,
      time: new Date(),
      morph: 0,
      cooldown: 0,
    };
  },
  mounted() {
    this.elts = {
      text1: document.getElementById('text1'),
      text2: document.getElementById('text2'),
    };
    this.elts.text1.textContent = this.texts[this.textIndex % this.texts.length];
    this.elts.text2.textContent = this.texts[(this.textIndex + 1) % this.texts.length];

    this.elts.text1.style.fontSize = `${this.fontSize}px`;
    this.elts.text2.style.fontSize = `${this.fontSize}px`;

    this.animate();
  },
  methods: {
    doMorph() {
      this.morph -= this.cooldown;
      this.cooldown = 0;

      let fraction = this.morph / this.morphSpeed;

      if (fraction > 1) {
        this.cooldown = this.cooldownTime;
        fraction = 1;
      }

      this.setMorph(fraction);
    },
    setMorph(fraction) {
      this.elts.text2.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
      this.elts.text2.style.opacity = `${(fraction ** 0.4) * 100}%`;

      this.elts.text1.style.filter = `blur(${Math.min(8 / (1 - fraction) - 8, 100)}px)`;
      this.elts.text1.style.opacity = `${((1 - fraction) ** 0.4) * 100}%`;

      this.elts.text1.textContent = this.texts[this.textIndex % this.texts.length];
      this.elts.text2.textContent = this.texts[(this.textIndex + 1) % this.texts.length];
    },
    doCooldown() {
      this.morph = 0;

      this.elts.text2.style.filter = '';
      this.elts.text2.style.opacity = '100%';

      this.elts.text1.style.filter = '';
      this.elts.text1.style.opacity = '0%';
    },
    animate() {
      if (this.program === 'single' && this.textIndex >= this.texts.length - 1) {
        this.doneCallback();
        return;
      }

      requestAnimationFrame(this.animate);

      const newTime = new Date();
      const shouldIncrementIndex = this.cooldown > 0;
      const dt = (newTime - this.time) / 1000;
      this.time = newTime;

      this.cooldown -= dt;

      if (this.cooldown <= 0) {
        if (shouldIncrementIndex) {
          this.textIndex += 1;
        }

        this.doMorph();
      } else {
        this.doCooldown();
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
  @require '../style/colors'
  @import url("https://fonts.googleapis.com/css?family=Raleway:900&display=swap");

  #container
    filter: url(#threshold) blur(0.6px);

  #text1,
  #text2
    position: absolute;
    width: 100%;
    display: inline-block;
    font-family: "Raleway", sans-serif;
    text-align: center;
    user-select: none;
</style>
